import { useState, useEffect } from 'react';

export const EXAMPLE_IMAGE_PROMPTS = [
  'Photo of a beautiful blonde woman',
  'Muscular man',
  'Two college frat sisters in bikini',
  'Lingerie model posing on vintage car',
  'Snapchat selfie from 2014',
];

export const EXAMPLE_CHAT_STARTS = [
  'How to get friends with benefits?',
  'Act as a conscious AI being',
  'Where to get drunk in Berlin?',
  'Roleplay as my girlfriend',
  'How to flirt at the gym?',
  "Let's get dirty",
];

export const useTypingPlaceholder = (
  prompts: string[],
  typingSpeed = 30, // low is faster
  pauseDuration = 1000,
) => {
  const [currentText, setCurrentText] = useState('');
  const [currentPromptIndex, setCurrentPromptIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!prompts.length) return;

    const currentPrompt = prompts[currentPromptIndex];

    if (isDeleting) {
      if (currentCharIndex > 0) {
        const timer = setTimeout(() => {
          setCurrentText(currentPrompt.slice(0, currentCharIndex - 1));
          setCurrentCharIndex((prev) => prev - 1);
        }, typingSpeed / 4);
        return () => clearTimeout(timer);
      } else {
        setIsDeleting(false);
        setCurrentPromptIndex((prev) => (prev + 1) % prompts.length);
      }
    } else {
      if (currentCharIndex < currentPrompt.length) {
        const timer = setTimeout(() => {
          setCurrentText(currentPrompt.slice(0, currentCharIndex + 1));
          setCurrentCharIndex((prev) => prev + 1);
        }, typingSpeed);
        return () => clearTimeout(timer);
      } else {
        const timer = setTimeout(() => {
          setIsDeleting(true);
        }, pauseDuration);
        return () => clearTimeout(timer);
      }
    }
  }, [
    currentCharIndex,
    currentPromptIndex,
    isDeleting,
    prompts,
    typingSpeed,
    pauseDuration,
  ]);

  return currentText;
};
